module.exports = __webpack_public_path__ + "static/img/search_no_data.6683f4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/search_no_data.png
// module id = 9jwg
// module chunks = 112